// src/components/Footer.tsx

import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
} from "react-icons/fa";

import { Mail, Phone, MapPin } from "lucide-react";
import orangeCape from "../assets/orangecape.png";

import "../styles/footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      {/* TOP */}

      <div className="footer-top">
        {/* BRAND */}

        <div className="footer-brand">
          <h2>
            Dagda
            <span>Nutrition</span>
          </h2>

          <p>
            Dagda Nutrition provides convenient, high-quality protein shakes
            through smart vending solutions designed for gyms, fitness centres,
            workplaces, and busy lifestyles. We carefully curate nutrition
            products from trusted supplement brands and combine them with fast,
            accessible vending technology to make healthy nutrition available
            anytime. Our goal is to make fitness nutrition simple, convenient,
            and accessible for people on the go. Dagda Nutrition is operated and
            managed by OrangeCape, which handles the technology platform,
            website management, and business operations behind the service.
          </p>

          <div className="footer-socials">
            <a href="/">
              <FaFacebookF />
            </a>

            <a href="/">
              <FaTwitter />
            </a>

            <a href="/">
              <FaInstagram />
            </a>

            <a href="/">
              <FaLinkedinIn />
            </a>
          </div>
        </div>

        {/* LINKS */}

        <div className="footer-links">
          <h3>Quick Links</h3>

          <a href="#home">Home</a>
          <a href="#about">About</a>
          <a href="#features">Features</a>
          <a href="#works">How It Works</a>
          <a href="#partnership">Partnership</a>
          <a href="#contact">Contact</a>
        </div>

        {/* RIGHT SIDE */}

        <div className="footer-right">
          {/* CONTACT */}

          <div className="footer-contact">
            <h3>Contact</h3>

            <div className="footer-contact-item">
              <MapPin size={18} />

              <span>Dublin, Ireland</span>
            </div>

            <div className="footer-contact-item">
              <Phone size={18} />

              <span>+353 89 2753452</span>
            </div>

            <div className="footer-contact-item">
              <Mail size={18} />

              <span>hello@dagdanutrition.com</span>
            </div>
          </div>

          {/* POWERED BY */}

          <a
  href="https://orangecape.ie"
  target="_blank"
  rel="noopener noreferrer"
  className="powered-by"
>

  <img
    src={orangeCape}
    alt="Orange Cape"
    className="powered-logo"
  />

  <span>
    Powered by
    <strong>
      Orange
      <b>Cape</b>
    </strong>
  </span>

</a>
        </div>
      </div>

      {/* BOTTOM */}

      <div className="footer-bottom">
        <p>© 2026 Dagda Nutrition. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
